// api/middlewares/index.ts
import { getEnv, navigate } from '@/common/agents';
import { CanvasErrorCodes } from '$/api/errorCode';
import { message } from '$/components/Message';
import { useCommonStore } from '@/store/useCommonStore';
import { redirectRemovedTeamMemberToPersonalHome } from '@/domains/team/redirectRemovedTeamMember';
import { isProjectAccessOverlayRoute } from '@/utils/projectAccessOverlayRoute';

/**
 * 调用方可在 request config 上声明 `skipErrorRedirect: true`，
 * 由自己处理失败态，中间件不再强制跳 404（用于分享落地页等场景）。
 */
function isRedirectSkipped(configLike: any): boolean {
  return Boolean(configLike?.skipErrorRedirect);
}

/** WebAPI 返回成员已被移除错误时，清理团队态并返回个人首页。 */
function handleRemovedTeamMember(errorCode: unknown): boolean {
  if (Number(errorCode) !== CanvasErrorCodes.TEAM_MEMBER_REMOVED) {
    return false;
  }
  return redirectRemovedTeamMemberToPersonalHome();
}

export const createCanvasErrorMiddleware = () => {
  return {
    onResponse: (response: any) => {
      const { code: error_code } = response?.data || {};
      if (handleRemovedTeamMember(error_code)) {
        return response;
      }
      switch (error_code) {
        case CanvasErrorCodes.LOGIN_EXPIRED:
          message.error('RoboNeo_Web_login_status_fail');
          useCommonStore.getState().toLogout();
          navigate({
            mode: 'url',
            url: getEnv().ENV === 'development' ? '/--roboneo/home' : '/home',
            replace: true,
          });

          break;
        case CanvasErrorCodes.ROOM_ACCESS_NOT_MATCH:
          if (!isProjectAccessOverlayRoute()) {
            navigate({
              mode: 'url',
              url: getEnv().ENV === 'development' ? '/--roboneo/home' : '/home',
              replace: true,
            });
          }
          break;
        case CanvasErrorCodes.FAST_REQUEST:
        case CanvasErrorCodes.SAFE_AUDIT_FAILED:
          message.error(response?.data.message);
          break;
        case CanvasErrorCodes.TEAM_SUB_GROUP_MISSING:
          message.error(response?.data.message);
          break;
        case CanvasErrorCodes.DEFAULT_ERROR:
        case CanvasErrorCodes.SHARE_CLOSE:
          if (!isRedirectSkipped(response?.config)) {
            navigate({
              mode: 'url',
              url: getEnv().ENV === 'development' ? '/--roboneo/404' : '/404',
              replace: true,
            });
          }
          break;
          // 网络错误todo,历史master的逻辑，从未触发待验证
        // default:
        //   message.error('RoboNeo_Web_network_error');
      }
      return response;
    },
    onError: (error: any) => {
      const { response, config } = error || {};
      const { code: error_code } = response?.data || {};
      if (handleRemovedTeamMember(error_code)) {
        return response;
      }
      switch (error_code) {
        case CanvasErrorCodes.LOGIN_EXPIRED:
          message.error('RoboNeo_Web_login_status_fail');
          useCommonStore.getState().toLogout();
          navigate({
            mode: 'url',
            url: getEnv().ENV === 'development' ? '/--roboneo/home' : '/home',
            replace: true,
          });
          break;
        case CanvasErrorCodes.ROOM_ACCESS_NOT_MATCH:
        case CanvasErrorCodes.COMMUNITY_NOT_PASSED:
          if (!isProjectAccessOverlayRoute()) {
            navigate({
              mode: 'url',
              url: getEnv().ENV === 'development' ? '/--roboneo/home' : '/home',
              replace: true,
            });
          }
          break;
        case CanvasErrorCodes.FAST_REQUEST:
        case CanvasErrorCodes.SAFE_AUDIT_FAILED:
          message.error(response?.data.message);
          break;
        case CanvasErrorCodes.TEAM_SUB_GROUP_MISSING:
          message.error(response?.data.message);
          break;
        case CanvasErrorCodes.DEFAULT_ERROR:
        case CanvasErrorCodes.SHARE_CLOSE:
          if (!isRedirectSkipped(response?.config || config)) {
            navigate({
              mode: 'url',
              url: getEnv().ENV === 'development' ? '/--roboneo/404' : '/404',
              replace: true,
            });
          }
          break;
      }

      return response;
    },
  };
};
